// Animations
export function animateIn(el) {
	el.style.display="flex"
	setTimeout(() => {
		el.classList.add('active') 
	}, 200);
}

export function animateOut(el) {
	el.classList.remove('active')
	setTimeout(() => {
		el.style.display="none"
	}, 500); 
}
